import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { GsIconComponent, GsOptimizedImageComponent } from 'libs/shared/src/components';
import { IconName } from 'libs/shared/src/models';
import { GsDropdownMenuItem } from 'libs/shared/src/controllers/gs-dropdown/models/dropdown-item';
import { DropdownStyleBase } from './dropdown-style-base';

@Component({
  selector: 'dropdown',
  imports: [CommonModule, GsOptimizedImageComponent, GsIconComponent, TranslatePipe],
  templateUrl: './dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``
})
export class DropdownComponent extends DropdownStyleBase {
  // Inputs & Models
  /** Tailwind margin class applied between a root-level glyph icon and its label */
  readonly glyphMarginClass = input('mr-3');
  /** Tailwind margin class applied between a sub-menu photo image and its label */
  readonly photoMarginClass = input('mr-3');

  // Methods
  /**
   * Returns the appropriate icon name for the chevron icon based on the menu state
   * The chevron must match the direction the submenu opens in: down/up for inline
   * (accordion) submenus, sideways for floating submenus that fly out next to the item.
   * @param menu The dropdown menu item
   * @returns The icon name for the chevron icon
   */
  menuChevronIcon(menu: GsDropdownMenuItem): IconName {
    if (this.openSubmenusInline()) return menu.opened ? 'caret-up' : 'caret-down';

    return menu.opened ? 'x' : 'caret-right';
  }
}
